import {Store} from '@ngrx/store';
import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {selectIsLoading} from '@common/core/reducers/view.reducer';
import {NavigationStart, Router} from '@angular/router';
import {debounce, distinctUntilChanged, filter, map} from 'rxjs/operators';
import {resetLoader} from '@common/core/actions/layout.actions';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {interval} from 'rxjs';
import {AsyncPipe} from '@angular/common';


@Component({
    selector: 'sm-spinner',
    template: `
    @if (loading$ | async) {
      <div class="loader-container">
        <mat-spinner [diameter]="64" [strokeWidth]="6" color="accent"></mat-spinner>
      </div>
    }
    `,
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatProgressSpinnerModule,
    AsyncPipe
  ]
})
export class SpinnerComponent {
  private store = inject(Store);
  private router = inject(Router);
  protected loading$ = this.store.select(selectIsLoading)
    .pipe(debounce(loading => interval((loading ? 0 : 200))));

  constructor() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationStart),
        map((event: NavigationStart) => event.url.split('?')[0]),
        distinctUntilChanged()
      ).subscribe(() => {
      this.store.dispatch(resetLoader());
    });
  }
}
